import type { PanelActionId } from './types'

/**
 * Display order for the action menu, sorted ascending.
 *
 * One map rather than a value in each action's own file, so the whole sequence
 * reads in one place.
 *
 * Sparse by 10 so a fifth action slots in without renumbering. The sequence is
 * the published design's: Watchlist, View manifest, Download manifest, AI
 * summary — identical inline and in the dropdown.
 */
export const PANEL_ACTION_ORDER: Record<PanelActionId, number> = {
  watchlist: 10,
  viewManifest: 20,
  downloadManifest: 30,
  aiSummary: 40,
}
